import _ from 'lodash';
import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';
import { fetchOnboardingFinishPage } from 'app/api/onboarding-api';
import { COLOR_MODES } from 'app/app-constants';
import Finish from 'app/components/setup/finish';

const { getStringsForPage } = contentfulModels;

const mapStateToProps = state => ({
  pageStrings: getStringsForPage(_.get(state, 'onboarding.finishPage')),
  finalHost: _.get(state.common, 'features').GFCORE_SITE_URL,
  isOrangeMode: _.get(state.onboarding, 'mode') === COLOR_MODES.ORANGE,
});

const FinishContainer = connect(mapStateToProps)(
  preload(
    ({ dispatch }) =>
      dispatch(fetchOnboardingFinishPage()),
  )(Finish),
);

export default FinishContainer;



// WEBPACK FOOTER //
// ./app/containers/setup/finish.js